













import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class ProgressModal extends Vue {

    doDisplay = false;

    @Prop()
    open!: boolean;

    @Prop()
    progress!: number;

    @Watch("open")
    onOpenChange() {
        if (this.open) {
            this.doDisplay = true;
        } else {
            setTimeout(() => {
                this.doDisplay = false;
            }, 500);
        }
    }

}
